import { render, staticRenderFns } from "./PromocionesVinoteca.vue?vue&type=template&id=55ec59ae&"
import script from "./PromocionesVinoteca.vue?vue&type=script&lang=js&"
export * from "./PromocionesVinoteca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports